export default __webpack_public_path__ + "static/04-3c73eb71ff2c20af4a0fa3d198280698.png";